<template>
  <!-- 头部组件 -->
  <div class="headerComponent">
    <div class="headerWarp">
      <div class="com_left">
        <div class="com_leftImg">
          <img v-lazy="require('@/assets/logo_header.png')" />
        </div>
        <div class="com_menuList" v-for="(item, index) in menuList" :key="index">
          <router-link :to="item.path">
            <p>{{ item.name }}</p>
          </router-link>
        </div>
      </div>
      <div class="com_right">
        <ul>
          <!-- <li v-if="headType">
            <div class="inputBox_warp">
              <div class="inputBox">
                <div class="inputbox_xialaLeft">
                  <selectComponent
                    @no-selectBottom="selectComponent_emitFn"
                    :selectList="selectComponent_data"
                    :defaultData="0"
                  />
                </div>
                <input
                  type="text"
                  class="inputbox_inputCenter"
                  @keyup.enter="retrievalFn"
                  v-model="search_val"
                />
                <span class="inputbox_bittonRight" @click="retrievalFn">检索</span>
              </div>
              <router-link to="/seniorSearch">
                <p>高级搜索</p>
              </router-link>
            </div>
          </li> -->
          <li :key="menuList.length + 1">
            <div v-show="!getTokenWhetherCanIsShow" class="user-actives-mask">
              <span @click="goRouter(2)">
                <img src="@/assets/loginHeaderImg.png" />注册
              </span> |
              <span @click="goRouter(1)">登录</span>
            </div>
            <!-- <personalRoute/> -->
            <div class="personalRoute_component" v-show="getTokenWhetherCanIsShow">
              <div class="personalRoute_left_img">
                <img :src="userInfoData.poster ? userInfoData.poster : require('@/assets/tx.png')" alt />
              </div>
              <div class="personalRouteDropDown_box">
                <el-dropdown trigger="click" @command="goPerRouter" @visible-change="visibleChange_right">
                  <el-button type="text">
                    <!-- 更多菜单<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <span>{{ userInfoData.user_name }}</span>
                    <img src="@/assets/jianTou.png" alt
                      :style="{ transform: dropdown_list_right ? 'rotate(180deg)' : 'rotate(90deg)' }" />
                  </el-button>
                  <el-dropdown-menu slot="dropdown" style="width: 120px;text-align: left;">
                    <el-dropdown-item v-for="(item, index) in dropdown_list" :key="index" :command="item"><i
                        :class="item.icon"></i>{{ item.name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import selectComponent from "@/components/common/select/index.vue";
import personalRoute from "./components/personalRoute.vue";
import { setToken, getToken } from "../../../static/js/util.js";
import { mapMutations } from "vuex";
export default {
  name: "headerComponent",
  data() {
    return {
      search_key: "0",
      search_val: "",
      getTokenWhetherCanIsShow: false,
      headType: true,
      dropdown_list_right: false,
      dropdown_list: [
        { name: "个人中心", path: "/personalCenter/account", icon: "el-icon-s-custom" },
        { name: "使用方", path: "/personalCenter/flow", icon: "el-icon-s-opportunity" },
        { name: "退出", path: "/", icon: "el-icon-s-help" }
      ],
      menuList: [
        {
          name: "首页",
          path: "/"
        },
        // {
        //   name: "果实微授权",
        //   path: "/microauthorization"
        // },
        {
          name: "果实信息流",
          path: "/informationFlow"
        }
      ],
      selectComponent_data: [
        //下拉框原始列表数据
        { title: "关键词", key: 0 },
        { title: "正文", key: 2 },
        { title: "标题", key: 1 },
        { title: "作者", key: 3 },
        { title: "期刊", key: 4 },
        { title: "栏目", key: 5 }
      ]
    };
  },
  watch: {
    $route(e) {
      this.whetherCanLogin();
      if (e.name != "searchResult") {
        this.search_val = "";
      }

      if (e.name == "userAccount") {
        this.headType = false;
      } else if (e.name == "userCollection") {
        this.headType = false;
      } else if (e.name == "seniorSearch") {
        this.headType = false;
      } else if (e.name == "accreditFlow") {
        this.headType = false;
      } else if (e.name == "accreditPackage") {
        this.headType = false;
      } else if (e.name == "accreditApiControl") {
        this.headType = false;
      } else {
        this.headType = true;
      }
    }
  },
  computed: {
    userInfoData() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    ...mapMutations(["setUserInfo", "keyset", "valset", "unique_code"]),
    whetherCanLogin() {
      //是否登录
      if (!getToken("unique_code")) {
        this.getTokenWhetherCanIsShow = false;
      } else {
        this.getTokenWhetherCanIsShow = true;
      }
    },
    dropdownCommand(res) {
      console.log(res);
    },
    selectComponent_emitFn(res) {
      //点击下拉选择框返回的数据
      this.search_key = res.key;
      console.log(res);
    },
    retrievalFn() {
      this.keyset(this.search_key);
      this.valset(this.search_val);
      this.$router.push({
        path: "/searchResult",
        query: { keyset: this.search_key, valset: this.search_val }
      });
    },
    goPerRouter(item) {
      if (item.name === "退出") {
        setToken("unique_code", "", 0);
        this.setUserInfo("");
        this.unique_code("");
        this.getTokenWhetherCanIsShow = false;
      }
      if (
        item.path === "/personalCenter/account" ||
        item.path === "/personalCenter/flow"
      ) {
        if (!getToken("unique_code")) {
          this.$message.warning("登录已过期，请重新登录");
          this.$router.push({ path: "/login" });
          return false;
        }
      }
      this.$router.push({ path: item.path });
    },
    visibleChange_right(res) {
      this.dropdown_list_right = res;
    },
    goRouter(val) {
      //1 登录  2注册
      if (val == 1) {
        this.$router.push({
          path: "login"
        });
      } else {
        this.$router.push({
          path: "login",
          query: {
            state: 2
          }
        });
      }
    }
  },
  mounted() {
    this.whetherCanLogin();
  },
  components: {
    selectComponent,
    personalRoute
  }
};
</script>

<style scoped lang="less">
.personalRoute_component {
  display: flex;
  align-items: center;

  .personalRoute_left_img {
    width: 24px;
    height: 24px;
    background: #e2e2e2;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;
    line-height: 24px;

    img {
      height: 100%;
    }
  }

  .personalRouteDropDown_box {
    span {
      padding: 0 5px 0 10px;
      font-weight: normal;
    }

    img {
      height: 12px !important;
      transition: 0.3s;
    }
  }
}

.headerComponent {
  height: 80px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);

  .headerWarp {
    width: 1200px;
    margin: auto;
    height: 100%;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .com_left {
      display: flex;
      justify-content: space-between;

      .com_leftImg {
        width: 115px;
        margin-right: 65px;

        img {
          width: 100%;
        }
      }

      .com_menuList {
        line-height: 55px;
        margin-right: 40px;
      }

      .com_menuList p:hover {
        color: #1966ff !important;
      }

      .com_menuList:last-child {
        margin-right: 0px;
      }
    }

    .com_right {
      ul {
        display: flex;
        align-items: center;

        li {
          margin-right: 40px;
        }

        li:last-child {
          margin-right: 0px;

          div {
            span {
              cursor: pointer;
              color: #152f6a;
              line-height: 24px;

              // display: flex;
              // display: inline-block;
              img {
                height: 24px;
                vertical-align: middle;
              }
            }
          }
        }
      }

      .inputBox_warp {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .inputBox {
          // overflow: hidden;
          width: 450px;
          height: 40px;
          display: flex;
          margin-right: 16px;
          align-items: center;
          border-radius: 6px;
          border: 1px solid rgba(21, 47, 106, 1);
          justify-content: space-between;

          .inputbox_xialaLeft {
            width: 80px;
            height: 100%;
            display: flex;
            align-items: center;
            // background: red;
          }

          .inputbox_inputCenter {
            display: block;
            width: 270px;
            height: 100%;
            outline: none;
            text-indent: 0.5em;
            border: none;
          }

          // .inputbox_bittonRight_warp{
          //     width: 100px;
          //     height: 100%;

          .inputbox_bittonRight {
            width: 100px;
            height: 100%;
            border: none;
            color: #ffffff;
            font-size: 14px;
            display: block;
            background: rgba(21, 47, 106, 1);
            transition: 0.3s;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }

          // }
          .inputbox_bittonRight:hover {
            background: #214da6;
          }

          .inputbox_bittonRight:active {
            background: rgba(21, 47, 106, 1);
          }
        }

        p {
          cursor: pointer;
          color: rgba(21, 47, 106, 1);
          transition: 0.3s;
        }

        p:hover {
          color: #1966ff !important;
        }

        p:active {
          color: rgba(21, 47, 106, 1);
        }
      }
    }
  }
}

.com_menuList p {
  font-size: 16px;
  font-weight: 600;
  color: rgba(21, 47, 106, 0.5);
}

.router-link-exact-active p {
  color: rgba(21, 47, 106, 1);
  font-weight: 600;
}

.el-dropdown-menu {
  width: 100px;
  text-align: center;
  top: 80px !important;
}

.user-actives-mask span:hover {
  color: #1966ff !important;
}
</style>
<style>
/* .headerComponent */
</style>



// WEBPACK FOOTER //
// src/components/headerComponent/headerComponent.vue